import { useDatasetPanelDetailsQuery } from '../../../../queries/useDatasetPanelDetailsQuery';

interface DatasetPanelValuesProps {
  coordinates?: number[];
  datasetId: string;
  category: string;
  storedGridCellSize: string;
  storedWaterDepth: string;
}

type DatasetPanelValuesReturnType = {
  gridCellSize: string;
  waterDepth: string;
  isCompleted: boolean;
};

// Mirrors how markerStore formats these values ('-' for null) so downstream payloads stay the same.
// TODO: SHOULD BE UNIFIED WHEN MARKER STORE WILL BE REMOVED!
const toPanelValue = (value: number | null | undefined, fallback: string) => {
  if (value === null) {
    return '-';
  }
  return value?.toString() ?? fallback;
};

/**
 * Grid cell size and water depth for the dataset currently selected in the modal.
 * The marker store is only synced after GetDatasetPanelDetails resolves, so right after
 * a dataset change it still holds the previous dataset's values — read the query instead.
 */
export const useDatasetPanelValues = ({
  coordinates,
  datasetId,
  category,
  storedGridCellSize,
  storedWaterDepth,
}: DatasetPanelValuesProps): DatasetPanelValuesReturnType => {
  const { data, isError, isPending } = useDatasetPanelDetailsQuery(coordinates, datasetId);

  // Same as useDatasetParameter: a failed request resets the values, except for Wind - why - should be addressed??
  if (isError && category !== 'Wind') {
    return { gridCellSize: '-', waterDepth: '-', isCompleted: true };
  }

  return {
    gridCellSize: toPanelValue(data?.gridCellSize, storedGridCellSize),
    waterDepth: toPanelValue(data?.waterDepth, storedWaterDepth),
    isCompleted: !isPending,
  };
};
